import { useState } from "react";

const useSidebarMenuContext = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(prev => !prev);

    return {
        isMenuOpen,
        toggleMenu
    }
};

export default useSidebarMenuContext;